import customFetch from "../util/config/axiosConfig";
import { ApiResponse } from "../types/responseType";
import {
  AddStudentForm,
  ApiStudentResponse,
  Student,
  StudentParams,
} from "../types/studentType";
import { toast } from "sonner";

const StudentApis = {
  //post
  addStudent: async (
    student: AddStudentForm,
  ): Promise<ApiResponse<AddStudentForm>> => {
    try {
      const response = await customFetch.post("/api/v1/student", {
        fullName: student.fullName,
        gender: student.gender,
        dateOfBirth: student.dateOfBirth,
        admissionYear: Number(student.admissionYear),
        academicCycleId: Number(student.academicCycleId),
        motherFullName: student.motherFullName,
        motherPhoneNumber: student.motherPhoneNumber,
        motherEmail: student.motherEmail,
        fatherFullName: student.fatherFullName,
        fatherPhoneNumber: student.fatherPhoneNumber,
        fatherEmail: student.fatherEmail,
        branchCode: student.branchCode,
        classId: student.classId ? Number(student.classId) : null,
        groupId: student.groupId ? Number(student.groupId) : null,
        studentCategory: student.studentCategory,
      });

      return response.data;
    } catch (error) {
      throw error;
    }
  },

  // GET Students
  getStudents: async (
    params: StudentParams,
  ): Promise<ApiStudentResponse | undefined> => {
    try {
      const response = await customFetch.get("/api/v1/student", {
        params: {
          branchCode: params.branchCode,
          page: params.page,
          size: params.size,
          ...(params.studentName && { studentName: params.studentName }),
          ...(params.parentContact && { parentContact: params.parentContact }),
          ...(params.groupId && { groupId: params.groupId }),
          ...(params.className && { className: params.className }),
          ...(params.academicCycleId && {
            academicCycleId: params.academicCycleId,
          }),
          ...(params.classId && { classId: params.classId }),
          ...(params.rollNo &&
            !isNaN(Number(params.rollNo)) && {
              rollNo: Number(params.rollNo),
            }),

          ...(params.studentAdmissionSequence &&
            !isNaN(Number(params.studentAdmissionSequence)) && {
              studentAdmissionSequence: Number(params.studentAdmissionSequence),
            }),
        },
      });

      return response.data;
    } catch (error) {
      console.error("Error in getStudents:", error);
      throw error;
    }
  },

  // delete
  deleteStudent: async (id: number): Promise<ApiResponse<null> | undefined> => {
    try {
      const response = await customFetch.delete(`/api/v1/student/${id}`);

      if (response.data.status === 1) {
        toast.success("Student deleted successfully!");
      } else {
        toast.error("Failed to delete student.");
      }

      return response.data;
    } catch (error) {
      console.error("Error in deleteStudent:", error);
      toast.error("Error deleting student.");
      throw error;
    }
  },

  // GET student by ID
  getStudentById: async (
    id: number,
  ): Promise<ApiResponse<Student> | undefined> => {
    try {
      const response = await customFetch.get(`/api/v1/student/${id}`);

      return response.data;
    } catch (error) {
      console.error("Error in getStudentById:", error);
      toast.error("Failed to fetch student details.");
      throw error;
    }
  },

  // PUT Update student
  updateStudent: async (
    student: Student,
  ): Promise<ApiResponse<Student> | undefined> => {
    try {
      const response = await customFetch.put("/api/v1/student", student);

      if (response.data.status === 1) {
        toast.success("Student updated successfully!");
      }
      return response.data;
    } catch (error) {
      console.error("Error in updateStudent:", error);
      toast.error("Error updating student.");
      throw error;
    }
  },

  changeStudentProfile: async (
    studentId: number,
    studentProfile: string,
  ): Promise<ApiResponse<string>> => {
    const response = await customFetch.patch(
      `/api/v1/student/update-profile/${studentId}`,
      studentProfile,
      {
        headers: {
          "Content-Type": "text/plain",
        },
      },
    );

    return response.data;
  },
};

export default StudentApis;
